import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  Menu,
  MenuItem,
  useTheme,
  Button,
  ListItemIcon,
  ListItemText,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import { DotsIcon } from "../../../Svg";
import { makeStyles } from "@mui/styles";
import { format } from "date-fns";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { headersGet } from "../../../Services/API";
import { AdminUrls } from "../../../Services/Routes/API";
import { MainRoutes } from "../../../Services/Routes/App";

const TransactionsListing = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const headings = [
    "id",
    "User",
    "Beneficiary",
    "Amount",
    "Reference ID",
    "Date",
    "Status",
    "",
  ];
  const rows = [
    {
      id: "000213",
      User: "Mr. Smith",
      Beneficiary: "Mrs. Smith",
      Amount: "N4500",
      Reference_ID: "bf4759994ww2",
      Date: "Jun 13, 2022",
      Status: "Sucessful",
    },
    {
      id: "000214",
      User: "Mr. Smith",
      Beneficiary: "Mrs. Smith",
      Amount: "N4500",
      Reference_ID: "bf4759994ww2",
      Date: "Jun 13, 2022",
      Status: "Sucessful",
    },
    {
      id: "000215",
      User: "Mr. Smith",
      Beneficiary: "Mrs. Smith",
      Amount: "N4500",
      Reference_ID: "bf4759994ww2",
      Date: "Jun 13, 2022",
      Status: "Sucessful",
    },
    {
      id: "000113",
      User: "Mr. Smith",
      Beneficiary: "Mrs. Smith",
      Amount: "N4500",
      Reference_ID: "bf4759994ww2",
      Date: "Jun 13, 2022",
      Status: "Sucessful",
    },
    {
      id: "000216",
      User: "Mr. Smith",
      Beneficiary: "Mrs. Smith",
      Amount: "N4500",
      Reference_ID: "bf4759994ww2",
      Date: "Jun 13, 2022",
      Status: "Sucessful",
    },
    {
      id: "000217",
      User: "Mr. Smith",
      Beneficiary: "Mrs. Smith",
      Amount: "N4500",
      Reference_ID: "bf4759994ww2",
      Date: "Jun 13, 2022",
      Status: "Sucessful",
    },
    {
      id: "000218",
      User: "Mr. Smith",
      Beneficiary: "Mrs. Smith",
      Amount: "N4500",
      Reference_ID: "bf4759994ww2",
      Date: "Jun 13, 2022",
      Status: "Sucessful",
    },
    {
      id: "000219",
      User: "Mr. Smith",
      Beneficiary: "Mrs. Smith",
      Amount: "N4500",
      Reference_ID: "bf4759994ww2",
      Date: "Jun 13, 2022",
      Status: "Sucessful",
    },
    {
      id: "000220",
      User: "Mr. Smith",
      Beneficiary: "Mrs. Smith",
      Amount: "N4500",
      Reference_ID: "bf4759994ww2",
      Date: "Jun 13, 2022",
      Status: "Sucessful",
    },
    {
      id: "000221",
      User: "Mr. Smith",
      Beneficiary: "Mrs. Smith",
      Amount: "N4500",
      Reference_ID: "bf4759994ww2",
      Date: "Jun 13, 2022",
      Status: "Sucessful",
    },
  ];

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [transactions, setTransactions] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");

  const useStyles = makeStyles({
    muiPaperShadowNone: {
      "& .MuiPaper-root": {
        boxShadow: "0px 3px 4px 0px rgb(30 63 138 / 3%)",
        minWidth: "100px",
      },
    },
    tableBodyText: {
      fontWeight: "400",
      fontSize: "13px",
      lineHeight: "20px",
      color: "#959595",
    },
  });

  // Dropdown
  const openn = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getAdminTransactions = () => {
    setOpen(true);
    headersGet(AdminUrls.GET_TRANSACTIONS_LISTING)
      .then((res) => {
        if (res?.status === 200 && res?.data?.success) {
          setTransactions(res?.data?.transactions);
          setOpen(false);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  useEffect(() => {
    getAdminTransactions();
  }, []);

  const classes = useStyles();

  return (
    <Box mt={6}>
      <Paper>
        <TableContainer component={Paper}>
          <Table
            sx={{ minWidth: 650, height: "200px" }}
            aria-label="simple table"
            stickyHeader
          >
            <TableHead>
              {" "}
              <TableRow>
                {headings?.map((h, index) => {
                  {
                    return (
                      <TableCell
                        sx={{ fontWeight: "bold" }}
                        key={`${index}-table-heading-${h}`}
                      >
                        {h}
                      </TableCell>
                    );
                  }
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {transactions?.map((row, index) => (
                <TableRow key={`${index}-row.name-${index + 2}`}>
                  <TableCell className={classes.tableBodyText}>
                    {row?.id}{" "}
                  </TableCell>
                  <TableCell className={classes.tableBodyText}>
                    {row?.sender_name || "N/A"}{" "}
                  </TableCell>
                  <TableCell className={classes.tableBodyText}>
                    {row?.receiver_name}{" "}
                  </TableCell>
                  <TableCell className={classes.tableBodyText}>
                    {row?.amount}{" "}
                  </TableCell>
                  <TableCell className={classes.tableBodyText}>
                    Ref: {row?.slug || "N/A"}
                  </TableCell>
                  <TableCell className={classes.tableBodyText}>
                    {row?.transfer_date
                      ? format(new Date(row?.transfer_date), "MM/dd/yyyy hh:mm")
                      : ""}{" "}
                  </TableCell>
                  <TableCell
                    sx={{
                      color:
                        row?.status === "successful"
                          ? theme.palette.success.main
                          : theme.palette.error.main,
                      fontWeight: "400",
                      fontSize: "13px",
                      lineHeight: "20px",
                    }}
                  >
                    {row?.status}{" "}
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      id="basic-button"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      onClick={handleClick}
                      // variant="outlined"
                      // onClick={() => addHandler(row)}
                      sx={{
                        borderRadius: 1,
                        minWidth: 0,
                        backgroundColor: "transparent",
                        padding: 0,
                      }}
                    >
                      <DotsIcon />
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={openn}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                      className={classes.muiPaperShadowNone}
                    >
                      <MenuItem>
                        <ListItemIcon>
                          {" "}
                          <VisibilityIcon />
                        </ListItemIcon>
                        <ListItemText>View</ListItemText>
                      </MenuItem>
                      <MenuItem>
                        <ListItemIcon>
                          {" "}
                          <DeleteIcon />
                        </ListItemIcon>
                        <ListItemText>Delete</ListItemText>
                      </MenuItem>
                    </Menu>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default TransactionsListing;
